import * as React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import CustomIcon from '../CustomIcon';

export class CustomSelect extends React.Component {
  state = {
    anchorOriginVertical: 'bottom',
    anchorOriginHorizontal: 'center',
    transformOriginVertical: 'top',
    transformOriginHorizontal: 'center',
    positionTop: 200,
    positionLeft: 400,
    buttonWidth: '100%'
  };

  static defaultProps = {
    open: false,
    className: ''
  };

  static propTypes = {
    options: PropTypes.array,
    itemNoSelected: PropTypes.object,
    handleClickMenuItem: PropTypes.func,
    handleCloseSelect: PropTypes.func,
    selectedItem: PropTypes.object,
    open: PropTypes.bool,
    buttonRef: PropTypes.any,
    openPopover: PropTypes.bool,
    showCheckedIcon: PropTypes.bool,
    className: PropTypes.string
  };

  componentDidUpdate(prevProps) {
    const { openPopover, buttonRef } = this.props;
    if (prevProps.openPopover !== openPopover) {
      this.setState({ open: openPopover });
    }
    if (!prevProps.buttonRef && buttonRef) {
      this.setState({ buttonWidth: buttonRef.clientWidth });
    }
  }

  renderOptionItems() {
    const { selectedItem, options, handleClickMenuItem, itemNoSelected, showCheckedIcon } = this.props;

    let items = [];

    if (itemNoSelected) {
      items.push(
        <MenuItem onClick={handleClickMenuItem} value={-1} className="menu-items" key={-1}>
          <span className="text-ellipsis">{I18n.t('gradebook.noSelected')}</span>
        </MenuItem>
      );
    }

    if (options) {
      options.forEach((option, i) => {
        let selected = selectedItem === option;
        items.push(
          <MenuItem
            onClick={() => {
              handleClickMenuItem(option);
            }}
            value={option.value}
            selected={selected}
            className={`menu-items ${selected ? 'selected' : ''}`}
            key={i}
          >
            <span className="text-ellipsis">{option.name}</span>
            {selected && showCheckedIcon ? <CustomIcon classes="success" name="check-icon" size={18} /> : ''}
          </MenuItem>
        );
      });
    }
    return items;
  }

  render() {
    const { buttonRef, open, handleCloseSelect, className } = this.props;
    const {
      buttonWidth,
      anchorOriginVertical,
      anchorOriginHorizontal,
      transformOriginVertical,
      transformOriginHorizontal,
      positionTop,
      positionLeft
    } = this.state;

    return (
      <div className={`select-container ${className}`}>
        <Popover
          open={open}
          onClick={handleCloseSelect}
          anchorEl={buttonRef}
          anchorPosition={{ top: positionTop, left: positionLeft }}
          onClose={this.handleRequestClose}
          anchorOrigin={{
            vertical: anchorOriginVertical,
            horizontal: anchorOriginHorizontal
          }}
          transformOrigin={{
            vertical: transformOriginVertical,
            horizontal: transformOriginHorizontal
          }}
          className="custom-popover"
        >
          <MenuList className="menu-list" style={{ width: buttonWidth }} open={open}>
            {this.renderOptionItems()}
          </MenuList>
        </Popover>
      </div>
    );
  }
}

export default CustomSelect;
